/* eslint max-len: 0 */

import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { ActivationCodesRepository, NewsRepository, LicensesRepository, AppIntegrationsRepository } from 'common/repositories/index';
// import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';
import eventManager from 'common/services/-RFC.eventManager';


angular.module('controllers')

    .controller(
        'DashboardNavigation',
        (
            $scope, $state, $stateParams,
            $rootScope, Util, $window,
        ) => {

            const { sidebarServices } = CWCONFIG;
            const { freeSupport } = CWCONFIG.partnerConfig.support;
            const serviceIdFromParam = $state.params.resourceId;
            const currentDateInMiliseconds = new Date().getTime();
            const lang = CWCONFIG.language;
            $scope.visiblePages = CWCONFIG.partnerConfig.pages;

            $rootScope.activeNavSection = window.activeNavSection;

            $rootScope.activeNavSection = window.activeNavSection;

            $scope.referralCode = Session.getValue(SessionKeys.ReferralCode) || '';

            if (localStorage.getItem('theme') === 'dark') {

                $scope.darkModeActivated = true;

            } else {

                $scope.darkModeActivated = false;

            }

            // get variant value from 'AB Test Subscriptions Expire Banner'
            $scope.expireBannerVariant = localStorage.getItem('ExpireBannerVariant');

            /**
            * Check if news are available
            */
            const blogLanguages = CWCONFIG.news.languages;
            const isAvailable = blogLanguages.find(language => language === lang);
            if (isAvailable) {

                $scope.newsAvailable = true;

            } else {

                $scope.newsAvailable = false;
                $scope.blogURL = 'https://www.avira.com/en/blog/';

            }

            /**
            * Check if how-to category is avalable, if not set threats category default
            */
            if (lang === 'en' || lang === 'de') {

                $scope.availableNewsCategory = 'how-to';

            } else if (lang === 'fr' || lang === 'it') {

                $scope.availableNewsCategory = 'threats';

            }

            if (lang === 'en') {

                $scope.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, 'en-us');

            } else {

                $scope.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, lang);

            }

            const activationCodesRepo = ActivationCodesRepository.getAll();
            const licensesRepo = LicensesRepository.getAll();

            // hide store and exclusive offer tab if user has an TP link licence
            $scope.hasTPLinkLicence = ActivationCodesRepository.hasTPLinkLicence();
            const { primeAppIds } = CWCONFIG || [];
            const userHasSubscriptions =
                activationCodesRepo.length > 0 || licensesRepo.length > 0;

            $scope.showPrimePage = false;

            if (userHasSubscriptions) {

                $scope.showPrimePage = true;

                // if the user has aps20 with runtime 36 dont show prime page
                activationCodesRepo.forEach((activationCode) => {

                    if (activationCode.attributes.app === 'aps20' && activationCode.attributes.runtime === 36) {

                        $scope.showPrimePage = false;

                    }

                });

            }

            const subjectActivationCodesRepository = ActivationCodesRepository.getObservable();
            subjectActivationCodesRepository
                .subscribe(
                    data => onNext(data),
                    () => { },
                    () => { },
                );

            const subjectLicenseRepository = LicensesRepository.getObservable();
            subjectLicenseRepository
                .subscribe(
                    data => onNextLicenses(data),
                    () => { },
                    () => { },
                );

            // Scrollbar
            $scope.scrollTop = 0;
            $scope.onScroll = (scrollTop) => {

                $scope.scrollTop = scrollTop;

            };

            function onNext(data) {

                const activationCodes = data;
                const expiringActivationCodes = [];
                $scope.showWarning = false;
                // Don't redirect the user to the subscriptions page if other subscriptions are expiring.
                // (redirect the user only if auto-renewal for Prime is OFF)
                $scope.hasActivePrime = ActivationCodesRepository.hasActivePrime();

                if (activationCodes.length > 0) {

                    $scope.supportForPaidUsers = true;

                }

                activationCodes.forEach((activationCode) => {

                    const expireNotificationDays = getExpireNotificationDays(activationCode);
                    const appId = activationCode.relationships.app.data.id;

                    // Find expiring licenses
                    const expirationDate = activationCode.attributes.date_expire;
                    if (expirationDate) {

                        const subscriptionExpirationDateInMs = moment(expirationDate).valueOf();
                        const remainingDaysUntilExpiration =
                            Math.ceil(moment.duration(subscriptionExpirationDateInMs - currentDateInMiliseconds).asDays());

                        if (remainingDaysUntilExpiration <= expireNotificationDays &&
                            activationCode.attributes.subscription === 0 &&
                            !Util.isNonrenewableApp(appId) &&
                            !$scope.hasActivePrime) {

                            $scope.showWarning = true;

                            const appName = AppIntegrationsRepository.getById(Util.deepFind(activationCode, 'relationships.app.data.id'));

                            expiringActivationCodes.push(Util.deepFind(appName, 'attributes.resource.oeName'));

                        }

                    }

                });

                // Send mixpanel event if there is at least one expiring license
                if (expiringActivationCodes.length) {

                    // redirect to subscriptions page
                    if (expiringActivationCodes.length === activationCodes.length) {

                        if (!$rootScope.redirectedToSubscriptions && $state.current.name.indexOf('.print-gdpr-report') === -1) {

                            if ($state.current.name !== 'root.dashboard.subscriptions.ltb') {

                                $rootScope.redirectedToSubscriptions = true;

                                $state.go('root.dashboard.subscriptions', {
                                    tab: 'plans',
                                }).then(() => {

                                    // Hide the warning icon when the current page is subscriptions
                                    $scope.isSubscriptionsPage = $state.current.name.indexOf('.subscriptions') > -1;

                                });

                            }

                        }

                    }

                    Mixpanel.send('Subscription Expire Notification', {
                        'Paid Products List': expiringActivationCodes.sort().join(),
                    });

                }

            }

            function onNextLicenses(data) {

                const licenses = data.filter(license => Util.deepFind(license, 'attributes.type') === 'eval');
                // Don't redirect the user to the subscriptions page if other subscriptions are expiring.
                // (redirect the user only if auto-renewal for Prime is OFF)
                $scope.hasActivePrime = ActivationCodesRepository.hasActivePrime();
                $scope.showWarningTrial = false;
                const expiringLicenses = [];
                const primeTrials = licenses.find(license => primeAppIds.indexOf(Util.deepFind(license, 'relationships.app.data.id')) > -1);

                // find expiring licenses
                licenses.forEach((license) => {

                    const expirationDate = license.attributes.expiration_date;
                    const expireNotificationDays = getExpireNotificationDays(license);


                    if (expirationDate) {

                        const subscriptionExpirationDateInMs = moment(expirationDate).valueOf();
                        const remainingDaysUntilExpiration =
                            Math.ceil(moment.duration(subscriptionExpirationDateInMs - currentDateInMiliseconds).asDays());

                        if (remainingDaysUntilExpiration <= expireNotificationDays &&
                            license.attributes.subscription === 0 &&
                            !$scope.hasActivePrime) {

                            $scope.showWarningTrial = true;

                            const appName = AppIntegrationsRepository.getById(Util.deepFind(license, 'relationships.app.data.id'));
                            const appId = Util.deepFind(license, 'relationships.app.data.id');
                            if ((primeAppIds.indexOf(appId) === -1) && primeTrials) {

                                $scope.showWarningTrial = false;

                            }
                            expiringLicenses.push(Util.deepFind(appName, 'attributes.resource.oeName'));

                            // prevent multiple redirects to subscriptions page
                            if (!$rootScope.redirectedToSubscriptions) {

                                if ($state.current.name !== 'root.dashboard.subscriptions.ltb' && $scope.showWarningTrial) {

                                    $rootScope.redirectedToSubscriptions = true;
                                    $state.go('root.dashboard.subscriptions', {
                                        tab: 'plans',
                                    }).then(() => {

                                        // Hide the warning icon when the current page is subscriptions
                                        $scope.isSubscriptionsPage = $state.current.name.indexOf('.subscriptions') > -1;

                                    });

                                }

                            }

                        }

                    }

                    return $scope.showWarningTrial;

                });

                // Send mixpanel event if there is at least one expiring trial
                if (expiringLicenses.length) {

                    Mixpanel.send('Subscription Expire Notification', {
                        'Trial Products List': expiringLicenses.sort().join(),
                    });

                }

            }

            // return the number of days to notify users that their subscription will expire based
            // param {obj} activationCode || license

            function getExpireNotificationDays(data) {

                const monthlyExpireNotificationDays = CWCONFIG.monthlySubscriptionExpirationReminderDays || 20;
                const annualExpireNotificationDays = CWCONFIG.annualSubscriptionExpirationReminderDays || 60;
                const annualSubscriptionTypes = ['annual', 'annual-trial', 'yearly'];
                let isAnnualSubscription = false;

                if (annualSubscriptionTypes.indexOf(data.attributes.subscription_type) > -1) {

                    if ((data.attributes.type === 'eval') &&
                    ((data.attributes.runtime_unit === 'months' && data.attributes.runtime <= 1) ||
                    (data.attributes.runtime_unit === 'days' && data.attributes.runtime <= 30))) {

                        isAnnualSubscription = false;

                    } else {

                        isAnnualSubscription = true;

                    }

                }

                return isAnnualSubscription ? annualExpireNotificationDays : monthlyExpireNotificationDays;

            }

            $scope.browserName = $window.browserName.toLowerCase();
            $scope.betaMode = CWCONFIG.betaMode;
            $scope.currentStateName = $state.current.name;
            $scope.currentResourceId = $state.params.resourceId;

            /* getServiceById looks through sidebar services which are located in the config file
            and returns the whole service object */
            const getServiceById = (serviceId) => {

                const service = _.findWhere(sidebarServices, { id: serviceId });

                return service;

            };

            // highlight in the navigation bar which service was selected
            // (ex: finantz blick or family locator)
            const setSelectedService = (serviceId) => {

                const service = getServiceById(serviceId) || {};

                $scope.selectedServiceId = service.id;

            };
            setSelectedService(serviceIdFromParam);

            $scope.$on('$stateChangeSuccess', () => {

                $scope.currentStateName = $state.current.name;
                $scope.currentResourceId = $state.params.resourceId;
                $rootScope.showMobileMenu = false;

            });

            /**
             * Handler for clicking on a tab.
             * @param {string} tabName The name of the clicked tab: 'securityApps',
             * 'devices', 'store'
             */
            $scope.onClickMenu = (tabName) => {

                $scope.content = tabName;
                $rootScope.showMobileMenu = false;
                $rootScope.mobileMenuAttribute = 'open-mobile-menu';
                $rootScope.redirectedToSubscriptions = true;
                $rootScope.activeNavSection = '';
                setTimeout(() => {

                    // Hide the warning icon when the current page is subscriptions
                    $scope.isSubscriptionsPage = $state.current.name.indexOf('.subscriptions') > -1;

                }, 0);

                /* mixpanel events */
                switch (tabName) {

                case 'devices':
                    Mixpanel.send('ConnectWeb Sidebar Devices Click');
                    break;
                case 'freeProducts':
                    Mixpanel.send('ConnectWeb Sidebar Free Products Click');
                    break;
                case 'store':
                    Mixpanel.send('ConnectWeb Sidebar Store Click');
                    break;
                case 'subscriptions':
                    Mixpanel.send('ConnectWeb Sidebar Subscriptions Click');
                    break;
                case 'home':
                    Mixpanel.send('ConnectWeb Sidebar Dashboard');
                    break;
                case 'support':
                    Mixpanel.send('ConnectWeb Sidebar Support Click');
                    break;
                case 'news':
                    Mixpanel.send('ConnectWeb Sidebar News Click');
                    break;
                case 'aia':
                    Mixpanel.send('ConnectWeb Sidebar AIA Click');
                    break;
                case 'renewal':
                    Mixpanel.send('ConnectWeb Sidebar Renewal Settings Click');
                    $rootScope.activeNavSection = 'renewal';
                    break;
                default:
                    break;

                }

                const newsPages = NewsRepository.getPageNumber();
                $scope.newsCurrentPage = newsPages.threats;

            };

            $rootScope.cookieBannerHeight = { 'padding-bottom': `${angular.element('.bottom-page-notification').outerHeight() + 8}px` };

            if (window.matchMedia) {

                window.matchMedia('(prefers-color-scheme: dark)').addListener((e) => {

                    if (e.matches) {

                        $rootScope.State.theme = 'dark';
                        $scope.currentTheme = 'dark';
                        $scope.darkModeActivated = true;

                    } else {

                        $rootScope.State.theme = 'light';
                        $scope.currentTheme = 'light';
                        $scope.darkModeActivated = false;

                    }

                    if ($state.current.name.indexOf('.print-gdpr-report') === -1) {

                        $rootScope.$apply();

                    }

                });

            }

            $scope.changeTheme = () => {

                let color;
                if ($scope.darkModeActivated) {

                    $scope.darkModeActivated = false;
                    color = 'light';

                } else {

                    $scope.darkModeActivated = true;
                    color = 'dark';

                }

                localStorage.setItem('theme', color);

                if (localStorage.getItem('theme') === 'dark') {

                    $rootScope.State.theme = 'dark';
                    $scope.currentTheme = 'dark';
                    Mixpanel.setCommonProperty('Theme', 'Dark');

                } else {

                    $rootScope.State.theme = 'light';
                    $scope.currentTheme = 'light';
                    Mixpanel.setCommonProperty('Theme', 'Light');

                }

                Mixpanel.send('ConnectWeb Theme Select Click', {
                    Label: color,
                });

            };

            $scope.onClickLogo = () => {

                Mixpanel.send('ConnectWeb Sidebar Logo Click');

            };

            $scope.onClickFeedback = () => {

                Mixpanel.send('ConnectWeb Sidebar Feedback Click');
                $rootScope.showMobileMenu = false;

            };

            $scope.onClickPrevVersion = () => {

                Mixpanel.send('ConnectWeb Sidebar Old Dashboard Click');
                $rootScope.showMobileMenu = false;

            };

            $scope.onClickMenuApp = (appId) => {

                const app = AppIntegrationsRepository.getById(appId);

                const appName = Util.deepFind(app, 'attributes.resource.oeName');

                Mixpanel.send(`ConnectWeb Sidebar ${appName} Click`);

                window.open(app.attributes.custom.manifest.product_url, '_blank');

            };

            $scope.productName = Util.deepFind((AppIntegrationsRepository.getById('pass1')), 'attributes.resource.oeName');

            eventManager.subscribe('user-menu:clicked', () => {

                $scope.onClickMenu('user-menu');

            });

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/navigation/navigation.js